import ModalLoader from './modal-loader';
export default ModalLoader;
